import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {rsaBasicModuleConfig} from '@/config'

///验证码
export const capthcaCodeModule = {
        ///获取验证码
        getCaptchaCode() {
            console.log('rsaBasicModuleConfig',rsaBasicModuleConfig)
            var header
            return httpRequest(baseUrl.basic + 'captchacode', 'get', null, header);
        },
        ///刷新验证码
        refreshCaptchaCode(header) {
            return httpRequest(baseUrl.basic + 're_ccode', 'post', null, header);
        },

    }
    ///登录
export const loginModule = {
    ///登录
    adminLogin(data, header) {
        return httpRequest(baseUrl.basic + 'newlogin', 'post', data, header);
    }
}